import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiService } from './api.service';

export interface Notification {
  id: number;
  type: number; // 1 = Script status changed, 2 = Update accepted, 4 = Milestone reached
  script_id: number | null;
  script_version: number | null;
  title: string;
  message: string;
  staff_comment: string | null;
  is_update: boolean;
  view_count: number | null;
  created_at: string;
  sent_at: string | null;
}

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  api: ApiService = inject(ApiService);
  notifications: BehaviorSubject<Notification[]> = new BehaviorSubject<Notification[]>([]);
  unreadCount: BehaviorSubject<number> = new BehaviorSubject<number>(0);

  loadNotifications() {
    this.api.get("notifications/user.php").subscribe((data: any) => {
      if (data.code === 200) {
        this.notifications.next(data.notifications || []);
        // Count unread (notifications without sent_at are considered unread for UI purposes)
        // For now, we'll consider all notifications as "read" once they're displayed
        // You can add a "read" field later if needed
        this.unreadCount.next(0);
      }
    });
  }

  getNotifications(): Observable<Notification[]> {
    return this.notifications.asObservable();
  }

  getUnreadCount(): Observable<number> {
    return this.unreadCount.asObservable();
  }

  getNotificationIcon(type: number): string {
    switch (type) {
      case 1: // Script status changed
        return 'check_circle';
      case 2: // Update accepted
        return 'check_circle';
      case 4: // Milestone reached
        return 'star';
      default:
        return 'notifications';
    }
  }

  getNotificationColor(type: number): string {
    switch (type) {
      case 1: // Script status changed
        return 'var(--mat-sys-primary)';
      case 2: // Update accepted
        return 'var(--mat-sys-tertiary)';
      case 4: // Milestone reached
        return 'var(--mat-sys-secondary)';
      default:
        return 'var(--mat-sys-on-surface)';
    }
  }
}

